import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { BaseResponseModel } from "@/models/core.model";
import { EventRecord, UpsertEventRecord } from '@/models/event-record.model';

export const getEventRecord = async (id: number): Promise<BaseResponseModel<EventRecord>> => {
  return await getReq(createUrl(`a/EventRecord/GetById/${id}`),
  ).then((res: any) => res.data);
};
export const getEventRecordByDistanceId = async (runEventDistanceId: number): Promise<BaseResponseModel<EventRecord>> => {
  return await getReq(createUrl(`a/EventRecord/GetByDistance`),
  {params : {runEventDistanceId}}
  ).then((res: any) => res.data);
};

export const upsertEventRecord = async (input: UpsertEventRecord): Promise<BaseResponseModel<EventRecord>> => {
  return await postReq(createUrl("a/EventRecord/Upsert"),
    input
  ).then((res: any) => res.data);
};
